export default {
  statusText(val) {
    switch (val) {
      case 1:
        return '计划中'
      case 2:
        return '点击报名'
      case 3:
        return '进行中'
      case 4:
        return '已结束'
      case 5:
        return '报项中'
      default:
        return '未知状态'
    }
  },
  statusColor(val) {
    switch (val) {
      case 1:
        return '#ffc000'
      case 2:
        return '#f73c13'
      case 3:
        return '#009900'
      case 4:
        return '#bbb'
      case 5:
        return '#009cff'
      default:
        return '#bbbbbb'
    }
  },
  statusArrowsColor(val) {
    switch (val) {
      case 1:
        return '#cc9900'
      case 2:
        return '#c42400'
      case 3:
        return '#006b00'
      case 4:
        return '#949494'
      case 5:
        return '#0071b8'
      default:
        return '#bbbbbb'
    }
  },
  detailMenu(programId, matchInfo, isMatchEmpower = 0) {
    let arr = [
      { title: '赛事主页', url: '/MatchDetail' }, // 赛事主页
      { title: '参赛数据', url: '/MatchAgency' }, // 参赛数据
      { title: '场次对战', url: '/MatchGame' }, // 场次对战
      { title: '奖牌榜', url: '/MatchRank' }, // 奖牌榜
      { title: '赛事公告', url: '/MatchNotice' }, // 赛事公告
    ]
    if (programId == 200) {
      arr[2] = { title: '成绩公示', url: '/PhysicalFitnessResult' } // 成绩公示
      arr[3] = { title: '排行榜', url: '/PhysicalFitnessRank' } // 排行榜
    }
    if (isMatchEmpower == 1) {
      arr.push({ title: '组委会', url: process.env.BUE_APP_MODEL_MATCHMANAGER_URL })
    }
    if (matchInfo && matchInfo.joinChannel === 'bigball') {
      arr.push({
        title: '积分榜',
        url: '/MatchLoopScore',
      })
      if (programId === 4) {
        arr.push({
          title: '射手榜',
          url: '/MatchLoopRank',
        })
        arr.push({
          title: '红黄牌榜',
          url: '/MatchLoopCard',
        })
      }
    }
    return arr
  },
  agencyTypeText(val) {
    switch (val) {
      case 'PERSON':
        return '个人'
      case 'CLUB':
        return '俱乐部'
      case 'ASSOCIATION':
        return '协会'
      case 'ENTERPRISE':
        return '企业'
      case 'INSTITUTION':
        return '事业单位'
      case 'GOVERNMENT':
        return '政府机关'
      case 'SCHOOL':
        return '学校'
      default:
        return '未知'
    }
  },
  staffTypeEnum() {
    return [
      {
        code: 'COACHMAIN',
        name: '主教练',
      },
      {
        code: 'COACHVICE',
        name: '副教练',
      },
      {
        code: 'LEADER',
        name: '领队',
      },
      {
        code: 'MANAGER',
        name: '经理',
      },
      {
        code: 'OFFICIAL',
        name: '官员',
      },
      {
        code: 'CAPTAIN',
        name: '队长',
      },
      {
        code: 'REFEREE',
        name: '裁判',
      },
      {
        code: 'DOCTOR',
        name: '队医',
      },
      {
        code: 'WORKER',
        name: '工作人员',
      },
    ]
  },
  getLeaderName(type) {
    switch (type) {
      case 'COACHMAIN':
        return '主教练'
      case 'COACHVICE':
        return '副教练'
      case 'LEADER':
        return '领队'
      case 'DOCTOR':
        return '队医'
      case 'MANAGER':
        return '经理'
      case 'OFFICIAL':
        return '官员'
      case 'CAPTAIN':
        return '队长'
      case 'REFEREE':
        return '裁判'
      case 'WORKER':
        return '工作人员'
      default:
        return '管理'
    }
  },
  getLeaderName2(type) {
    // 主教练副教练统一修改为教练
    switch (type) {
      case 'COACHMAIN':
        return '教练'
      case 'COACHVICE':
        return '教练'
      case 'LEADER':
        return '领队'
      case 'DOCTOR':
        return '队医'
      case 'MANAGER':
        return '经理'
      case 'OFFICIAL':
        return '官员'
      case 'CAPTAIN':
        return '队长'
      case 'REFEREE':
        return '裁判'
      case 'WORKER':
        return '工作人员'
      default:
        return '管理'
    }
  },
  formatDate(value, isTime) {
    var date
    if (value instanceof Date) {
      date = value
    } else if (value instanceof Object) {
      date = value._d
    } else {
      var arr = value.split(/[- : /]/)
      if (value.indexOf(':') > -1) {
        date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5])
      } else {
        date = new Date(arr[0], arr[1] - 1, arr[2])
      }
    }
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    if (!isTime) {
      return Y + M + D
    }
    var h = ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
  },
  randomNumFile(name, url) {
    var randomNum = Math.floor(Math.random() * 100000)
    var file = {
      uid: randomNum + '',
      name: name,
      status: 'done',
      url: url,
      response: { data: { url: url } },
    }
    return file
  },
  agencyTypeEnum() {
    return [
      {
        code: 'CLUB',
        name: '俱乐部',
      },
      {
        code: 'ASSOCIATION',
        name: '协会',
      },
      {
        code: 'SCHOOL',
        name: '学校',
      },
      {
        code: 'ENTERPRISE',
        name: '企业',
      },
      {
        code: 'INSTITUTION',
        name: '事业单位',
      },
      {
        code: 'GOVERNMENT',
        name: '政府机关',
      },
      {
        code: 'PERSON',
        name: '个人',
      },
    ]
  },
  centerMenuList(bool) {
    let arr = [
      {
        name: '普通运动员',
        url: 'CenterPlayer',
      },
      {
        name: '团队管理',
        url: 'CenterCoach',
      },
      {
        name: '球队管理',
        url: 'CenterTeam',
      },
    ]
    if (bool) {
      arr.unshift({
        name: '注册运动员',
        url: 'CenterAthlete',
      })
    }
    return arr
  },
  menuNameByCode(code) {
    switch (code) {
      case 'CenterAuth':
        return '授权管理'
      case 'CenterAthlete':
        return '注册运动员'
      case 'CenterPlayer':
        return '普通运动员'
      case 'CenterCoach':
        return '团队管理'
      case 'CenterTeam':
        return '球队管理'
    }
  },
  phoneFun(phones) {
    var myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
    if (!myreg.test(phones)) {
      console.log('手机号格式不正确')
      return false
    } else {
      console.log('手机号格式正确')
      return true
    }
  },
  emailFun(email) {
    var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
    return reg.test(email)
  },
  getPayType(signCostStatus) {
    switch (signCostStatus) {
      case 'FREE':
        return '收费模式：免报名费'
      case 'PEOPLECHARGE':
        return '收费模式：按首项 + 加项收费'
      case 'COMBOCHARGE':
        return '收费模式：按项目组合收费'
      case 'TEAMCHARGE':
        return '收费模式：按队伍收费'
      default:
        return '收费模式：未知'
    }
  },
  getEventBg(programId) {
    switch (Number(programId)) {
      case 1:
        return '1'
      case 2:
        return '2'
      case 5:
        return '5'
      case 4:
        return '4'
      case 11:
        return '11'
      default:
        return '1'
    }
  },
}



// WEBPACK FOOTER //
// ./src/comm/utils/matchFun.js